// extracted by mini-css-extract-plugin
export default {"bottomLabel":"_2co-vzvun3cARMA1z2dViY","centerLabel":"_1NQIkQsiSneyzpzSEckb0c","topLabel":"_2drnydKyDyk-fsWQl4wens","claimSummaryCell":"goWlRxZ2Ocfo6hhxX_zSd"};